<app-site-nav-bar></app-site-nav-bar>

<div class="main-app-area">
  <router-outlet></router-outlet>
</div>